export const tableOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  editBtn: false,
  delBtn: false,
  addBtn: false,
  viewBtn: false,
  column: [
    {
      label: '标题',
      width: 360,
      prop: 'title',
      search: true,
      searchPlaceholder: '请输入',
      overHidden: true,
    },
    {
      label: '作者',
      width: 180,
      prop: 'postedByName',
      search: true,
      searchPlaceholder: '请输入',
      solt: true,
    },
    {
      label: '专栏',
      width: 180,
      prop: 'columnName',
      search: true,
      searchPlaceholder: '请输入',
      solt: true,
    },
    {
      label: '评论',
      width: 110,
      prop: 'commentCount',
      sortable: true,
      solt: true,
    },
    {
      label: '收藏',
      width: 110,
      prop: 'favoriteCount',
      sortable: true
    },
    {
      label: '点赞',
      width: 110,
      prop: 'likeCount',
      sortable: true
    },
    {
      label: '打赏',
      width: 110,
      prop: 'rewardCount',
      solt: true,
      sortable: true
    },
    {
      label: '状态',
      width: 110,
      prop: 'statusText'
    },
    {
      label:'评论开关',
      width: 100,
      type:'select',
      prop:'commentEnabled',
      solt: true,
      span:24,
      dicData: [{
        label: '关闭',
        value: false
      }, {
        label: '开启',
        value: true
      }]
    },
    {
      label: '发布时间',
      prop: 'postTime',
      sortable: true,
      width: 180,
    },
    {
      // type: 'datetime',
      // valueFormat: 'timestamp',
      // format: 'yyyy-MM-dd hh:mm:ss',
      label: '修改时间',
      width: 180,
      prop: 'lastEditTime',
      sortable: true,
      align: 'center'
    }
  ]
}

export const statusOptions = [
  {id: 1, text: '已上架'},
  {id: 2, text: '已下架'},
  {id: 3, text: '已删除'}
]

export const commentsTableOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  editBtn: false,
  delBtn: false,
  addBtn: false,
  viewBtn: false,
  menu: false,
  column: [
    // {label: 'ID', prop: 'id', width: '100px'},
    {label: '评论者', prop: 'commentByName', width: 200, overHidden: true},
    {label: '回复对象', prop: 'commentToName', width: 200, overHidden: true},
    {label: '评论时间', prop: 'commentTime', width: 180},
    {label: '评论内容', prop: 'content', align: 'left'}
  ]
}
